<template>
  <div class="p-work">
    <div class="p-block">
      <div class="p-block-title">
        <p class="main">{{ baseData.title }}</p>
        <p class="sub">{{ baseData.subtitle }}</p>
      </div>
    </div>
    <ul>
      <li v-for="(item, index) in baseData.list" :index="index" :key="index">
        <p>
          <KdIcon :icon="item.icon" :size="48"></KdIcon>
        </p>
        <p>{{ item.name }}</p>
        <p>{{ item.desc }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { workData } from './../../config.js';
import KdIcon from '@/components/KdIcon/index.vue';
export default {
  name: 'work-component',
  components: { KdIcon },
  data() {
    return {
      baseData: workData,
    };
  }
};
</script>

<style lang="scss" scoped>
.p-work {
  margin: 0 auto;
  ul {
    margin: 48px auto 0 auto;
    width: 960px;
    li {
      display: inline-block;
      width: 140px;
      height: 140px;
      text-align: center;
      margin-right: 24px;
      padding: 12px 0;
      box-sizing: border-box;
      :deep(.target) {
        margin-right: 0;
      }
      &:first-child {
        :deep(.target) {
          color: rgba(255, 21, 34, 1);
        }
      }
      &:nth-child(6n) {
        margin-right: 0;
      }
      p:nth-child(1) {
        margin-bottom: 16px;
      }
      p:nth-child(2) {
        font-weight: 600;
        font-size: 16px;
        line-height: 26px;
        color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));
      }
      p:nth-child(3) {
        line-height: 22px;
        font-size: 14px;
        color: var(--kd-color-text-secondary, rgba(13, 13, 13, 0.66));
      }
    }
  }

  @include responsiveV2($width-m) {
    ul {
      width: 840px;
      padding: 0 72px;
      box-sizing: border-box;
      text-align: center;
      li {
        &:nth-child(4n) {
          margin-right: 0 !important;
        }
        &:nth-child(6n) {
          margin-right: 24px;
        }
      }
    }
  }
}
</style>
